import { setActiveSection } from '@UI/Pages/Beneficiaries/BeneficiaryDetails/Pages/Documents/DocumentDetails/Signals/activeSectionSignal';
import { closeDocumentPanel } from '@UI/Pages/Beneficiaries/BeneficiaryDetails/Pages/Documents/DocumentDetails/Signals/documentPanelSignal';
import { setDocumentFullscreen } from '@UI/Pages/Beneficiaries/BeneficiaryDetails/Pages/Documents/DocumentDetails/Signals/documentFullscreenSignal';
import { setEditingField } from '@UI/Pages/Beneficiaries/BeneficiaryDetails/Pages/Documents/DocumentDetails/Signals/editingFieldSignal';
import { setPendingDiscard } from '@UI/Pages/Beneficiaries/BeneficiaryDetails/Pages/Documents/DocumentDetails/Signals/pendingDiscardSignal';
import { setSelectedField } from '@UI/Pages/Beneficiaries/BeneficiaryDetails/Pages/Documents/DocumentDetails/Signals/selectedFieldSignal';
import { setVerificationFilter } from '@UI/Pages/Beneficiaries/BeneficiaryDetails/Pages/Documents/DocumentDetails/Signals/verificationFilterSignal';

/**
 * Puts every screen-local signal back to its initial value: React Router reuses this screen's element
 * when only `:document` changes, so nothing of a previous document's session — an open panel, a draft,
 * a pending discard, the active section, the chosen filter — must survive into the next one.
 */
const resetDocumentVerificationSignals = (): void => {
	setSelectedField(null);
	closeDocumentPanel();
	setEditingField(null);
	setPendingDiscard(null);
	setActiveSection('');
	setVerificationFilter({ type: 'all' });
	setDocumentFullscreen(false);
};

export default resetDocumentVerificationSignals;
